import { Login as LoginComponent } from 'features/Login';
import { LoginProps } from 'features/Login/types';

const Login = ({ isWelcome }: LoginProps): JSX.Element => {
	return <LoginComponent isWelcome={!!isWelcome} />;
};
export default Login;
